export const msisdn = {
  type: 'text',
  inputMode: 'text',
  placeholder: 'Cell number',
  name: 'msisdn',
  disabled: false,
  dark: false,
  hideUnderline: true,
  hint:'We will send a verification to this number'
};